import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogActions } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { AppInsightsService } from '../../services/appinsights/appinsights.service';
import { LocaleComponent } from '../Locale/locale.component';

@Component({
    standalone: true,
    selector: 'app-cancel-confirmation',
    templateUrl: './cancel-confirmation.component.html',
    imports: [LocaleComponent, MatDialogActions]
})
export class CancelConfirmationComponent {
  @Input() localeView!: string;
  @Input() lang!: string;

  private ngUnsubscribe$: Subject<boolean> = new Subject();
  private dialogRef: any;

  constructor(private router: Router, private route: ActivatedRoute, private dialog: MatDialog, private appInsightsService: AppInsightsService) { }

  openDialog(content: any): void {
    this.appInsightsService.logEvent(`${this.localeView.toUpperCase()} cancel confirmation opened`);
    this.dialogRef = this.dialog.open(content, {
      panelClass: 'custom-dialog-container'
    });
  }

  closeDialog(): void {
    this.appInsightsService.logEvent(`${this.localeView.toUpperCase()} cancel confirmation closed`);
    this.dialogRef.close();
  }

  goBackToStart(): void {
    this.appInsightsService.logEvent(`${this.localeView.toUpperCase()} cancel confirmation confirmed`);
    let action = 'opt';

    switch (true) {
      case this.localeView.startsWith('OPT_OUT'):
        action = 'optout'
        break;
      case this.localeView.startsWith('OPT_DWN'):
        action = 'optdwn'
        break;
      case this.localeView.startsWith('OPT_UP'):
        action = 'optup'
        break;
      case this.localeView.startsWith('OPT_IN'):
        action = 'optin'
        break;
      default:
        action = 'all';
        break;
    }

    this.router.navigateByUrl(`customer/${action}/${this.lang}`);
    this.dialog.closeAll();
  }
}
